import type { CatalogItem, CatalogStatus } from '@/lib/catalog'

export function getCatalogStatus(item: Pick<CatalogItem, 'slug' | 'status'>): CatalogStatus {
  return item.status ?? 'available'
}
